import { Box } from '@mui/material';
import { BRAND } from '../../theme/brandTokens';

const typingDotSx = (delayMs) => ({
  width: 7,
  height: 7,
  borderRadius: '50%',
  bgcolor: BRAND.accent,
  animation: 'supportTypingDot 1s ease-in-out infinite',
  animationDelay: `${delayMs}ms`,
});

const SupportTypingDots = ({ align = 'start', label }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: align === 'end' ? 'flex-end' : 'flex-start',
      mb: 1,
      '@keyframes supportTypingDot': {
        '0%, 60%, 100%': { transform: 'translateY(0)', opacity: 0.35 },
        '30%': { transform: 'translateY(-6px)', opacity: 1 },
      },
    }}
    aria-label={label}
    role="status"
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.6,
        px: 1.5,
        py: 1.25,
        minHeight: 36,
        borderRadius: 2,
        bgcolor: '#fff',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
      }}
    >
      <Box sx={typingDotSx(0)} />
      <Box sx={typingDotSx(150)} />
      <Box sx={typingDotSx(300)} />
    </Box>
  </Box>
);

export default SupportTypingDots;
